import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3c94f312&scoped=true&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=3c94f312&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c94f312",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c94f312')) {
      api.createRecord('3c94f312', component.options)
    } else {
      api.reload('3c94f312', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3c94f312&scoped=true&lang=pug", function () {
      api.rerender('3c94f312', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consultant/vipRequests/confirmModal/index.vue"
export default component.exports